var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip",on:{"click":_vm.selectEvent}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.close)?_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":_vm.closeEvent}},[_vm._v("×")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }